import { Address } from '@dreryk/address-common-api';

import { StyledFlex } from '@dreryk/react-components';

import { VisitLocationIcon } from './VisitLocationIcon';
import { StyledText, StyledVisitLocationText } from './VisitLocationText.styled';
import { VisitLocationTooltip } from './VisitLocationTooltip';

type VisitLocationTextProps = {
   readonly name: string;
   readonly address: Address;
};

export const VisitLocationText = (props: VisitLocationTextProps): JSX.Element => {
   return (
      <StyledVisitLocationText>
         <VisitLocationTooltip name={props.name} address={props.address}>
            <StyledFlex gap='4px' alignItems='center'>
               <div>
                  <VisitLocationIcon />
               </div>
               <StyledText testId='visitLocation'>{props.name}</StyledText>
            </StyledFlex>
         </VisitLocationTooltip>
      </StyledVisitLocationText>
   );
};
